<template>
    <div :class="{ map: !mapBoxShow, full_map: mapBoxShow }">
        <div class="gaode-map">
            <el-amap
                vid="map-location"
                :center="mapCenter"
                :zoom="zoom"
                :plugin="plugin"
            >
                <div class="seach" ref="seach">
                    <div class="content-list" v-loading="loading">
                        <div class="list_item">
                            <template v-if="$route.path != '/direct-jb' && typeStr != 'direct-jb'">
                                <MaptenderDetails
                                    v-for="(item, index) in tenderList"
                                    :key="index"
                                    :item="item"
                                    :index="index"
                                    @showDetails="showDetails"
                                    :isList="true"
                                ></MaptenderDetails>
                            </template>
                            <template v-else>
                                <MapBidDetails
                                    v-for="(item, index) in tenderList"
                                    :key="index"
                                    :item="item"
                                    :index="index"
                                    @showDetails="showDetails"
                                    :isList="true"
                                ></MapBidDetails>
                            </template>
                            <div
                                class="loadMore"
                                @click="loadMore"
                                v-if="
                                    tenderList.length &&
                                    tenderList.length != pageMachineLabor.total
                                "
                            >
                                加载更多
                            </div>
                        </div>
                        <!-- <base-empty-data
                            v-else-if="tenderList.length === 0 && !loading"
                        /> -->
                    </div>
                </div>
                <el-amap-marker :position="center">
                    <img
                        src="https://api.map.baidu.com/images/marker_red_sprite.png"
                        alt
                    />
                </el-amap-marker>
                <el-amap-marker
                    v-for="(marker, index) in markers"
                    :position="marker.position"
                    :events="marker.events"
                    :key="index"
                ></el-amap-marker>
                <el-amap-info-window
                    v-if="window"
                    :position="window.position"
                    :visible="window.visible"
                >
                    <template v-if="$route.path != '/direct-jb'  && typeStr != 'direct-jb'">
                        <MaptenderDetails
                            :item="window.content"
                            :isList="false"
                        ></MaptenderDetails>
                    </template>
                    <template v-else>
                        <MapBidDetails
                            :item="window.content"
                            :isList="false"
                        ></MapBidDetails>
                    </template>
                </el-amap-info-window>
                <div class="LabelBox">
                    <div class="addressIcon" @click="getResAddress(2)">
                        <i class="el-icon-map-location"></i>
                    </div>
                    <div
                        :class="['addressIcon', zoom >= 18 ? 'UnShow' : null]"
                        @click="getAmplification"
                    >
                        <i class="el-icon-plus"></i>
                    </div>
                    <div
                        :class="['addressIcon', zoom <= 4 ? 'UnShow' : null]"
                        @click="getNarrow"
                    >
                        <i class="el-icon-minus"></i>
                    </div>
                    <div class="addressIcon" @click="handleFullScreen">
                        <img src="@/assets/fullscreen.png" alt="" />
                    </div>
                </div>
            </el-amap>
        </div>
    </div>
</template>

<script>
import axios from '@/http/zhaocai'
import {getPosition} from '@/storage/mapPosition.js'
var map, geolocation
export default {
  mixins:[getPosition],
  props: {
    propsObj: {
      type: Object,
      required: true
    },
    typeStr: {
      type: String,
      required: true
    },
    positionAddress: {
      type: Object,
      required: true
    },
    mapBoxShow: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isboolean: true,
      cloneCenter: [],
      local: [],
      leaseValue: '',
      map: null,
      zoom: 16,
      mapCenter: [121.59996, 31.197646],
      center: [121.59996, 31.197646],
      activeName: '',
      positionlng: 0,
      positionlat: 0,
      markers: [],
      windows: [],
      window: '',
      lock: false,
      lng: '',
      lat: '',
      pageMachineLabor: {
        limit: 20,
        page: 1,
        total: 0,
        type: null,
        city: '', // 市
        name: '', // 招标名称
        state: '', // 招标状态
        longitude: '',
        latitude: '',
        distance: 1000
      },
      tenderList: [],
      loading: false,
      plugin: [
        // {
        //     pName: "ToolBar",
        //     position: "RB",
        //     ruler: true,
        //     locate: true,
        //     autoPosition: true,
        // },
        // {
        //     pName: "Geolocation",
        //     position: "RB",
        //     events: {
        //         init(o) {
        //             // o 是高德地图定位插件实例
        //             o.getCurrentPosition((status, result) => {
        //                 if (result && result.position) {
        //                     self.lng = result.position.lng;
        //                     self.lat = result.position.lat;
        //                     self.center = [self.lng, self.lat];
        //                     self.$nextTick();
        //                 }
        //             });
        //         },
        //     },
        // },
      ]
    }
  },
  created(){
    this.initGdMap()
    this.pageMachineLabor.longitude = this.$store.state.position.lng
    this.pageMachineLabor.latitude = this.$store.state.position.lat
  },
  components: {
    MaptenderDetails: () =>
      import('@/views/hotTender/components/maptenderDetails'),
    MapBidDetails: () => import('@/views/hotTender/components/mapBidDetails')
  },
  filters: {
    formatKm (val) {
      return `${Number(val) / 1000}km`
    },
    formatBus (val) {
      let str = ''
      if (val) {
        val.forEach(item => {
          str += `${item.firstCategoryName}/`
        })
        str = str.slice('/', -1)
        return str
      }
    }
  },
  watch: {
    positionAddress: {
      handler (val) {
        if (val && val.point) {
          this.pageMachineLabor.longitude = val.point.lng
          this.pageMachineLabor.latitude = val.point.lat
          this.mapCenter = [val.point.lng, val.point.lat]
          this.center = [val.point.lng, val.point.lat]
          this.tenderList = []
          this.getMachineLaborList()
        }
      },
      deep: true,
      immediate: true
    },
    propsObj: {
      handler (newObj, oldObj) {
        this.pageMachineLabor.page = 1
        this.tenderList = []
        switch (this.$route.path) {
          case '/zb-gg':
            this.pageMachineLabor.type = newObj.tenderTypeShow.no
            this.pageMachineLabor.city = newObj.listShow.no
            this.pageMachineLabor.areacode = newObj.areaListShow.no
            this.pageMachineLabor.verticalType = newObj.modeTypeShow.no
            this.pageMachineLabor.goodsType = newObj.projeCateShow.no
            if (newObj.timeListShow) {
              // 时间
              this.pageMachineLabor.time = newObj.timeListShow.no
            }
            if (newObj.priceListShow) {
              // 金额
              this.pageMachineLabor.price = newObj.priceListShow.no
            }
            if (newObj.tenderStatusShow) {
              // 状态
              this.pageMachineLabor.state = newObj.tenderStatusShow.no
            }
            if (newObj.biddingMethodShow) {
              this.pageMachineLabor.biddingMethod = newObj.biddingMethodShow.no
            }
            // 搜索的
            this.pageMachineLabor['name'] = newObj.searchData.searchName
            if (this.$route.path == '/direct-jb') {
              this.pageMachineLabor['companyName'] =
                newObj.searchData.companyName
            } else {
              this.pageMachineLabor['comName'] = newObj.searchData.companyName
            }
            if (newObj.searchData.mapDistance) {
              this.pageMachineLabor.distance = Number(
                newObj.searchData.mapDistance
              )
            }
            if (newObj.timeListShow) {
              this.pageMachineLabor.time = newObj.timeListShow.no
            }
            this.getMachineLaborList()
            break
          case '/zb':
            this.pageMachineLabor.type = newObj.tenderTypeShow.no
            this.pageMachineLabor.city = newObj.listShow.no
            this.pageMachineLabor.areacode = newObj.areaListShow.no
            this.pageMachineLabor.verticalType = newObj.qualificationWayShow.no
            this.pageMachineLabor.goodsType = newObj.projeCateShow.no
            if (newObj.timeListShow) {
              // 时间
              this.pageMachineLabor.time = newObj.timeListShow.no
            }
            if (newObj.priceListShow) {
              // 金额
              this.pageMachineLabor.price = newObj.priceListShow.no
            }
            if (newObj.tenderStatusShow) {
              // 状态
              this.pageMachineLabor.state = newObj.tenderStatusShow.no
            }
            if (newObj.biddingMethodShow) {
              this.pageMachineLabor.biddingMethod = newObj.biddingMethodShow.no
            }
            // 搜索的
            this.pageMachineLabor['name'] = newObj.searchData.searchName
            if (this.$route.path == '/direct-jb') {
              this.pageMachineLabor['companyName'] =
                newObj.searchData.companyName
            } else {
              this.pageMachineLabor['comName'] = newObj.searchData.companyName
            }
            if (newObj.searchData.mapDistance) {
              this.pageMachineLabor.distance = Number(
                newObj.searchData.mapDistance
              )
            }
            this.getMachineLaborList()
            break
          case '/direct-jb':
            this.pageMachineLabor.type = newObj.tenderTypeShow.no
            this.pageMachineLabor.cityNo = newObj.listShow.no
            this.pageMachineLabor.areacode = newObj.areaListShow.no
            this.pageMachineLabor.goodsType = newObj.projeCateShow.no
            if (newObj.priceListShow) {
              // 金额
              this.pageMachineLabor.price = newObj.priceListShow.no
            }
            this.pageMachineLabor['name'] = newObj.searchData.searchName
            this.pageMachineLabor['comName'] = newObj.searchData.comName
            if (newObj.searchData.mapDistance) {
              this.pageMachineLabor.distance = Number(
                newObj.searchData.mapDistance
              )
            } else if (newObj.searchData.mapDistance == '') {
              this.pageMachineLabor.distance = 1000
            }
            this.getMachineLaborList()
            break
          default:
            break
        }
      },
      deep: true,
      immediate: true
    }
  },
  async mounted () {
    await this.initMap()
  },
  methods: {
    getNarrow () {
      if (this.zoom > 4) {
        this.zoom = this.zoom - 1
      }
    },
    getAmplification () {
      if (this.zoom < 18) {
        this.zoom = this.zoom + 1
      }
    },
    getResAddress () {
      this.mapCenter = [...this.center]
    },
    getMachineLaborList () {
      this.initApi()
      if (this.api === '') return false
      this.loading = true
      axios
        .post(this.api, this.pageMachineLabor)
        .then(res => {
          this.loading = false
          if (res.data.result) {
            this.tenderList = this.tenderList.concat(res.data.result)
            this.$forceUpdate()
          }
          this.addMark()
          // this.pageMachineLabor.total = res.data.total || res.data.result.total
          this.pageMachineLabor.total = res.total
        })
        .catch(err => {
          console.log(err)
          this.loading = false
        })
    },
    loadMore () {
      this.pageMachineLabor.page++
      this.getMachineLaborList()
    },
    initApi () {
      // console.log(this.typeStr,'this.typeStr');
      if (this.typeStr == 'direct-jb') {
        this.api = '/ov1/tender/es/findBidPageEsMap'
        return
      }
      switch (this.$route.path) {
        case '/zb-gg':
          this.api = '/ov1/mechanicalLabor/tenderApplyingEsMap'
          break
        case '/zb':
          this.api = '/ov1/mechanicalLabor/tenderBidderListEsMap'
          break
        // case "/jb":
        //     this.api = "/ov1/mechanicalLabor/tenderEvaluatingList";
        //     break;
        case '/direct-jb':
          this.api = '/ov1/tender/es/findBidPageEsMap'

          break
        default:
          break
      }
    },
    colseSeach (isboolean) {
      // 关闭搜索
      if (isboolean) {
        this.$refs.content.style.height = '0px'
        this.$refs.seach.style.height = '60px'
        this.isboolean = false
      } else {
        this.$refs.content.style.height = '630px'
        this.$refs.seach.style.height = '750px'
        this.isboolean = true
      }
    },
    seachParms () {
      // 搜索功能
      this.$emit('seachParms', this.leaseValue)
    },
    openNewUrl (obj) {},
    toEnterprise (ids, nos) {
      this.$emit('toEnterprise', ids, nos)
    },
    handleTeamName (val) {
      this.$emit('handleTeamNames', val)
    },
    getnumber (index) {
      console.log(index)
    },
    handleClick (e) {
      this.$emit('tabCheck', e.index)
    },
    germore (e) {
      console.log(this.scrollHeight)
      this.$emit('parentAdd', e)
    },
    initMap () {
      let _this = this
      // 加载地图，调用浏览器定位服务
      map = new AMap.Map('map-location', {
        resizeEnable: true
      })

      map.plugin('AMap.Geolocation', () => {
        geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, // 是否使用高精度定位，默认:true
          timeout: 1000000, // 超过10秒后停止定位，默认：无穷大
          maximumAge: 0, // 定位结果缓存0毫秒，默认：0
          convert: true, // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: true, // 显示定位按钮，默认：true
          buttonPosition: 'RB', // 定位按钮停靠位置，默认：'LB'，左下角
          buttonOffset: new AMap.Pixel(10, 20), // 定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          showMarker: false, // 定位成功后在定位到的位置显示点标记，默认：true
          showCircle: true, // 定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true, // 定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true // 定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        })

        map.addControl(geolocation)
        // 首先去获取local中缓存的定位
        let localPosition = localStorage.getItem('position')
        if (localPosition) {
          localPosition = JSON.parse(localPosition)
          _this.center = [localPosition.lng, localPosition.lat]
          _this.cloneCenter = [localPosition.lng, localPosition.lat]
          _this.mapCenter = [localPosition.lng, localPosition.lat]
          _this.pageMachineLabor.latitude = localPosition.lat
          _this.pageMachineLabor.longitude = localPosition.lng
          // _this.addMark();
        }
      })
    },
    addMark () {
      let _this = this
      let markers = []
      let windows = []
      this.markers = markers
      this.windows = windows
      for (let i = 0; i < this.tenderList.length; i++) {
        if (this.tenderList[i].localLng && this.tenderList[i].localLat) {
          markers.push({
            position: [
              this.tenderList[i].localLng,
              this.tenderList[i].localLat
            ],
            events: {
              click (e) {
                _this.windows.forEach(window => {
                  window.visible = false
                })
                _this.window = _this.windows[i]
                _this.$nextTick(() => {
                  _this.window.visible = true
                })
              }
            }
          })

          windows.push({
            position: [
              this.tenderList[i].localLng,
              this.tenderList[i].localLat
            ],
            content: this.tenderList[i],
            visible: false
          })
          this.lock = true
        }
      }

      this.markers = markers
      this.windows = windows
    },
    getDistance (lat1, lng1, lat2, lng2) {
      let EARTH_RADIUS = 6378.137
      let radLat1 = this.rad(lat1)
      let radLat2 = this.rad(lat2)
      let a = radLat1 - radLat2
      let b = this.rad(lng1) - this.rad(lng2)
      let s =
        2 *
        Math.asin(
          Math.sqrt(
            Math.pow(Math.sin(a / 2), 2) +
              Math.cos(radLat1) *
                Math.cos(radLat2) *
                Math.pow(Math.sin(b / 2), 2)
          )
        )
      s = s * EARTH_RADIUS
      // s = Math.round(s * 10000d) / 10000d;
      s = Math.round(s * 10000) / 10000
      s = s * 1000 // 乘以1000是换算成米
      return s
    },
    rad (d) {
      return (d * Math.PI) / 180.0
    },
    markerClick (e, twoE, index) {
      this.mapCenter = [e, twoE]
      this.markers[index].events.click()
    },
    showDetails (e, twoE, index) {
      this.mapCenter = [e, twoE]
      this.markers[index].events.click()
    },
    handleFullScreen () {
      this.$emit('fullScreen')
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.map {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    .seach {
        position: absolute;
        top: 0;
        width: 315px;
        background-color: #fff;
        height: 750px;
        box-sizing: border-box;
        .content-list {
            height: 700px;
            background-color: #fff;
            width: 315px;
            .list_item {
                overflow-y: auto;
                height: 100%;
            }
        }
    }
  }
  .gaode-map {
    width: 100%;
    height: 750px;
    .el-vue-amap-container {
      position: relative;
      height: 100%;
      .info {
        position: relative;
        top: 0;
        right: 0;
        min-width: 0;
      }
    }
  }
.loadMore {
  height: 50px;
  width: 100%;
  text-align: center;
  line-height: 50px;
  color: #0286df;
  cursor: pointer;
}
.LabelBox {
  border: 1px solid #ddd;
  position: absolute;
  bottom: 40px;
  right: 40px;
  background: #ffffff;
  font-size: 24px;
  cursor: pointer;

  .addressIcon {
    padding: 5px 10px;
    border-bottom: 1px solid #f1f1f1;

    &:nth-child(4) {
      border-bottom: none;
      padding: 12px 0;
    }

    img {
      display: block;
      margin: 0 auto;
    }
  }

  .UnShow {
    color: #999;
  }
}
.full_map {
  width: 100vw;
  margin: 0 auto;
  overflow: hidden;
  .seach {
    position: absolute;
    top: 0;
    width: 315px;
    background-color: #fff;
    height: 850px;
    box-sizing: border-box;
    .content-list {
      height: 850px;
      overflow: auto;
      background-color: #fff;
      width: 315px;
    }
  }
  .gaode-map {
    width: 100%;
    height: 850px;
    .el-vue-amap-container {
      position: relative;
      height: 100%;
      .info {
        position: relative;
        top: 0;
        right: 0;
        min-width: 0;
      }
    }
  }
}
</style>
